import React from "react";
import _ from "lodash";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

const FormikInput: React.FC<any> = ({
  field: { ...fields },
  form: { errors, touched },
  ...props
}) => {
  const {
    id,
    maxLength,
    isDefaultValue,
    multiline,
    className,
    hasObject = false,
    controlClassName,
    sx,
    noMaxLength,
    setMyTranscript,
    ...rest
  } = props;

  const error = Boolean(
    _.get(touched, fields?.name) && _.get(errors, fields?.name)
  );

  const getError = () => {
    let errorString: any = errors;
    if (hasObject)
      fields?.name
        ?.split(".")
        .map((name: string) => (errorString = errorString[name]));
    return errorString;
  };

  return (
    <FormControl
      fullWidth
      className={`${multiline && "formikInput"} ${controlClassName}`}
      sx={sx}
    >
      {props?.label && <InputLabel>{props?.label}</InputLabel>}
      {isDefaultValue ? (
        <OutlinedInput
          {...fields}
          {...rest}
          id={id}
          className={className}
          multiline={multiline}
          error={error}
          autoComplete="off"
          inputProps={{
            maxLength: noMaxLength ? -1 : maxLength ? maxLength : 100,
          }}
        />
      ) : (
        <OutlinedInput
          {...fields}
          {...rest}
          id={id}
          className={className}
          value={
            props.type === "number"
              ? fields?.value || ""
              : fields?.value?.toString()?.trimStart()
          }
          multiline={multiline}
          error={error}
          autoComplete="off"
          inputProps={{
            maxLength: noMaxLength ? -1 : maxLength ? maxLength : 100,
          }}
        />
      )}
      {error && (
        <FormHelperText error className="mb-0">
          {error && (hasObject ? getError() : errors[fields?.name])}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormikInput;
